import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ViewContainersService } from '@urbannex/view-containers';

export const routes:Routes = [
  {
    path:'',
    redirectTo: 'customers', pathMatch: 'full'
  },
  {
    path:'customers',
    loadChildren:() => import('./customers/customer.module')
    .then(m => m.CustomerModule)
  },
  {
    path:'suppliers',
    loadChildren:() => import('./suppliers/supplier.module')
    .then(m => m.SupplierModule)
  },
  {
    path:'employees',
    loadChildren:() => import('./employees/employee.module')
    .then(m => m.EmployeeModule)
  }

]


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ]
})
export class PartymgrRoutingModule { 
  

  constructor(
    private viewContainerService:ViewContainersService,
    private menuService:NbMenuService,){
    
    
  }
}
